export default function first(array) {
    return (array && array.length) ? array[0] : undefined;
}
